<template>
  <div class="e2-container-card">
    <div v-if="$slots.header"
      class="e2-container-card__header"
      ref="header">
      <slot name="header" />
    </div>
    <div class="e2-container-card__body"
      ref="body">
      <div class="e2-container-card__body-card">
        <a-spin :spinning="pageLoading"
          :delay="delayTime">
          <slot/>
        </a-spin>
      </div>
    </div>
    <div v-if="$slots.footer"
      class="e2-container-card__footer"
      ref="footer">
      <slot name="footer" />
    </div>
    <!-- toTop -->
    <a-back-top :visibilityHeight="200"
      style="right:20px;bottom:20px;" />
  </div>
</template>

<script>
import normal from './mixins/normal';

export default {
  name: 'e2-container-card',
  mixins: [normal],
};
</script>
